import { saveKioskSurveyApi, saveKitchenSurveyApi, saveKitchenDiningSurveyApi } from "../../services/surveyService";
import { setLoading, setError, setSuccess } from "./surveySlice";

export const submitKioskSurvey = (payloadData) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    dispatch(setError(null));
    dispatch(setSuccess(false));

    // Convert plain object payload to FormData
    const formData = new FormData();
    Object.keys(payloadData).forEach((key) => {
      const value = payloadData[key];
      // Append only if the value is not null and not undefined
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    const response = await saveKioskSurveyApi(formData);

    // Assuming successful response if no error is thrown
    dispatch(setSuccess(true));
    return response;
  } catch (error) {
    // console.log(error);
    const errorMessage = error?.message || "Failed to submit survey";
    dispatch(setError(errorMessage));
    throw error;
  } finally {
    dispatch(setLoading(false));
  }
};

export const submitKitchenSurvey = (payloadData) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    dispatch(setError(null));
    dispatch(setSuccess(false));

    // Convert plain object payload to FormData
    const formData = new FormData();
    Object.keys(payloadData).forEach((key) => {
      const value = payloadData[key];
      // Append only if the value is not null and not undefined
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    const response = await saveKitchenSurveyApi(formData);

    // Assuming successful response if no error is thrown
    dispatch(setSuccess(true));
    return response;
  } catch (error) {
    // console.log(error);
    const errorMessage = error?.message || "Failed to submit survey";
    dispatch(setError(errorMessage));
    throw error;
  } finally {
    dispatch(setLoading(false));
  }
};


export const submitKitchenDiningSurvey = (payloadData) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    dispatch(setError(null));
    dispatch(setSuccess(false));

    // Convert plain object payload to FormData
    const formData = new FormData();
    Object.keys(payloadData).forEach((key) => {
      const value = payloadData[key];
      // Append only if the value is not null and not undefined
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    const response = await saveKitchenDiningSurveyApi(formData);

    // Assuming successful response if no error is thrown
    dispatch(setSuccess(true));
    return response;
  } catch (error) {
    // console.log(error);
    const errorMessage = error?.message || "Failed to submit survey";
    dispatch(setError(errorMessage));
    throw error;
  } finally {
    dispatch(setLoading(false));
  }
};